import { render, staticRenderFns } from "./MobileTopCategory.vue?vue&type=template&id=a37383e0&scoped=true&"
import script from "./MobileTopCategory.vue?vue&type=script&lang=js&"
export * from "./MobileTopCategory.vue?vue&type=script&lang=js&"
import style0 from "./MobileTopCategory.vue?vue&type=style&index=0&id=a37383e0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37383e0",
  null
  
)

export default component.exports